import * as Long from "long";
import { ofType } from "redux-observable";
import { from } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../../utils/network/generated/protoTypes";
import { actionBaseInfoAddBuilding } from "../../../info/base/actionBaseInfo";
import { actionInventoryInfoRemoveBuilding } from "../../../info/inventory/actionInventoryInfo";
import { actionBuildingsCancelUnstoreBuilding, actionBuildingsDeselect, TypeActionBuildings, } from "../actionBuildings";
export var epicBuildingsFinishUnstoreBuilding = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.FinishUnstoreBuilding), switchMap(function (action) {
        var state = state$.value;
        var _a = action.building, balancing = _a.balancing, proto = _a.proto;
        return deps
            .netSend({
            id: CommandCode.UnstoreBuilding,
            props: {
                farmId: state.playerBase.base.baseId,
                flipped: proto.flipped,
                playerId: state.playerInfo.playerId,
                posX: proto.posX,
                posY: proto.posY,
                stageId: proto.stage,
                typeId: balancing.id,
            },
        })
            .pipe(switchMap(function (res) {
            var itemInfo = [
                {
                    amount: Long.ONE,
                    stageId: res.building.stage,
                    typeId: res.building.typeId,
                },
            ];
            return from([
                actionBuildingsDeselect(),
                actionInventoryInfoRemoveBuilding(itemInfo),
                actionBaseInfoAddBuilding(res.building),
            ]);
        }), catchError(function () { return from([actionBuildingsCancelUnstoreBuilding()]); }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingsFinishUnstoreBuilding.ts
// module id = 2056
// module chunks = 3